import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Loader from "./Loader";
import Main from "./layout/Main";

const PrivateRoute = () => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <Loader />;
  }

  return isAuthenticated ? (
    <Main>
      <Outlet />
    </Main>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoute;
